import gql from 'graphql-tag'

export const JOBFUNCTIONLIST = gql`
 {
	filterJobFunction {
		_id
		name
		searchTags
	}
}


`